<template>
  <!-- 头部整体盒子 -->
  <div>
    <!-- <img src="http://192.168.1.60:9898/track/pixel" alt="" style="display: none; width: 1px;height: 1px;"> -->
    <img src="https://tianqi.tqzl-tech.com/api/track/pixel" alt="" style="display: none; width: 1px;height: 1px;">
    <div id="header-placeholder"></div>
    <div id="header" class="container-fuild">
      <!-- 电脑导航 -->
      <div class="header-nav container hidden-xs">
        <!-- 导航logo -->
        <div class="header-nav-logo">
          <router-link to="/" @click.native="handleLogoClick">
            <img src="@/assets/img/tqzl.png" />
          </router-link>
        </div>
        <div style="display: flex; align-items: center; overflow: hidden">
          <ul class="header-nav-wrapper">
            <li
              v-for="(item, index) in navList"
              :key="index"
              :class="index == navIndex ? 'active' : ''"
              @click="navClick(index, item)"
            >
              <router-link :to="item.path">
                {{ item.name }}
                <i class="underline"></i>
              </router-link>
            </li>
          </ul>
        </div>
      </div>
      <!-- 手机导航 -->
      <div class="header-nav-m container-fuild visible-xs">
        <div class="header-nav-m-logo">
          <router-link
            to="/"
            class="center-block"
            @click.native="handleLogoClick"
          >
            <img src="@/assets/img/tqzl.png" alt="logo" />
          </router-link>
        </div>
        <!-- 导航栏 -->
        <div class="header-nav-m-menu text-center">
          {{ menuName }}
          <div
            class="header-nav-m-menu-wrapper"
            data-toggle="collapse"
            data-target="#menu"
            @click="menuClick"
          >
            <span :class="menuClass"></span>
          </div>
          <!-- 导航内容 -->
          <ul id="menu" class="header-nav-m-wrapper collapse">
            <li
              v-for="(item, index) in navList"
              :key="index"
              :class="index == navIndex ? 'active' : ''"
              @click="navClick(index, item)"
              data-toggle="collapse"
              data-target="#menu"
            >
              <router-link :to="item.path">
                {{ item.name }}
                <i class="underline"></i>
              </router-link>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { getClassify, getClassifyByCode } from "../api/api"; // 导入接口
export default {
  name: "Header",
  data() {
    return {
      navIndex: sessionStorage.getItem("navIndex") ? parseInt(sessionStorage.getItem("navIndex")) : 0,
      menuName: "杭州天启智联科技有限公司 电话:0571-86998376",
      menuClass: "glyphicon glyphicon-menu-down",
      navList: [],
      // 移除固定初始code，改为动态获取
    };
  },
  mounted() {
    this.updateNavIndex();
    this.updateMenuName();
    window.addEventListener("scroll", () => {
      const header = document.getElementById("header");
      if (window.scrollY > 50) {
        header.classList.add("scrolled");
      } else {
        header.classList.remove("scrolled");
      }
    });
  },
  watch: {
    $route(to, from) {
      this.updateNavIndex();
      this.updateMenuName();
    },
  },
  created() {
    this.getList(); // 仅加载导航数据，不默认调用homePage接口
  },
  methods: {
    getList() {
      getClassify().then((res) => {
        console.log("导航数据:", res.data);
        this.navList = res.data;
        // 导航数据加载完成后，根据当前路由初始化对应的code
        this.initCodeByCurrentRoute();
      }).catch(err => {
        console.error("获取导航数据失败:", err);
      });
    },
    // 根据当前路由初始化对应的code
    initCodeByCurrentRoute() {
      const currentPath = this.$route.path.endsWith("/")
        ? this.$route.path.slice(0, -1)
        : this.$route.path;

      // 找到当前路由对应的导航项
      const currentNav = this.navList.find(item => {
        const itemPath = item.path.endsWith("/")
          ? item.path.slice(0, -1)
          : item.path;
        return currentPath === itemPath || (itemPath === "" && currentPath === "/");
      });

      if (currentNav && currentNav.code) {
        // 调用当前导航项对应的code接口
        this.handleCodeRequest(currentNav.code, currentNav.path);
        // 更新sessionStorage中的code
        sessionStorage.setItem("currentCode", currentNav.code);
      } else {
        // 未找到对应项时默认使用首页（可选）
        const homeNav = this.navList[0];
        if (homeNav && homeNav.code) {
          this.handleCodeRequest(homeNav.code, homeNav.path);
          sessionStorage.setItem("currentCode", homeNav.code);
        }
      }
    },
    handleLogoClick() {
      this.navIndex = 0;
      sessionStorage.setItem("navIndex", 0);
      this.menuName = "首页";
      // 点击logo时强制使用首页code
      const homeNav = this.navList[0];
      if (homeNav && homeNav.code) {
        this.handleCodeRequest(homeNav.code, homeNav.path);
        sessionStorage.setItem("currentCode", homeNav.code);
      }
    },
    // 导航点击事件：接收完整item参数以获取code
    navClick(index, item) {
      console.log("点击导航项:", item);
      this.navIndex = index;
      sessionStorage.setItem("navIndex", index);
      this.menuName = item.name;

      // 调用当前点击项的code接口
      if (item.code) {
        this.handleCodeRequest(item.code, item.path);
        sessionStorage.setItem("currentCode", item.code); // 存储当前code
      } else {
        this.$router.push(item.path);
      }
    },
    // 处理code请求并跳转
    async handleCodeRequest(code, path) {
      try {
        console.log("调用接口code:", code);
        const result = await getClassifyByCode(code);
        console.log("接口返回结果:", result.data);
        this.$store.dispatch('updateCodeData', result.data);
        this.$router.push(path);
      } catch (error) {
        console.error("接口调用失败:", error);
        this.$router.push(path);
      }
    },
    menuClick() {
      this.menuClass = this.menuClass === "glyphicon glyphicon-menu-down"
        ? "glyphicon glyphicon-menu-up"
        : "glyphicon glyphicon-menu-down";
    },
    updateNavIndex() {
      const path = this.$route.path.endsWith("/")
        ? this.$route.path.slice(0, -1)
        : this.$route.path;

      const index = this.navList.findIndex((item) => {
        const itemPath = item.path.endsWith("/")
          ? item.path.slice(0, -1)
          : item.path;
        return path === itemPath || (itemPath === "" && path === "/");
      });

      if (index !== -1) {
        this.navIndex = index;
        sessionStorage.setItem("navIndex", index);
        // 同步更新当前路由对应的code
        const currentNav = this.navList[index];
        if (currentNav && currentNav.code) {
          sessionStorage.setItem("currentCode", currentNav.code);
        }
      }
    },
    updateMenuName() {
      const path = this.$route.path;
      const currentNav = this.navList.find((item) => item.path === path);
      if (currentNav) {
        this.menuName = currentNav.name;
      }
    },
  },
};
</script>
<style scoped>
/* 原有样式保持不变 */
#header {
  background: #fff;
  width: 100%;
  transition: all ease 0.6s;
  display: flex;
  flex-wrap: nowrap;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  z-index: 1000;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
}
#header-placeholder {
  height: 80px; /* 电脑端导航高度 */
}
#header .header-top {
  height: 50px;
  color: #fff;
  font-size: 12px;
  line-height: 50px;
  background: #474747;
}
#header .header-top span {
  margin: 0 8px;
}
#header .header-nav {
  width: 100%;
  height: 80px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
#header .header-nav .header-nav-logo {
  width: 150px;
  height: 100%;
  float: left;
  position: relative;
  margin-right: 20vw;
}
#header .header-nav .header-nav-logo img {
  width: 100%;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  margin: auto;
}
#header .header-nav .phone {
  display: inline;
  float: right;
  margin-left: 20px;
  font-weight: bold;
  width: 130px;
}
#header .header-nav .phone img {
  height: 30px;
  width: 30px;
  display: inline;
}
#header .header-nav-fixed .header-nav-wrapper {
  line-height: 50px;
}
#header .header-nav .header-nav-wrapper {
  line-height: 210px;
  height: 210px;
  margin: 0;
  max-width: 800px;
  flex: 1;
  display: flex;
}
#header .header-nav .header-nav-wrapper > li {
  margin: 0 15px;
  position: relative;
}
#header .header-nav .header-nav-wrapper > li > a {
  color: #000;
  font-size: 18px;
  font-weight: normal;
  padding: 15px;
  position: relative;
}
#header .header-nav .header-nav-wrapper > li > a > i {
  display: block;
  position: absolute;
  bottom: -2px;
  left: 50%;
  width: 0;
  height: 2px;
  opacity: 0;
  transition: all 0.6s ease;
  background-color: #449aff;
}
#header .header-nav .header-nav-wrapper > li > a > span {
  font-size: 12px;
  transition: transform ease 0.5s;
}
#header .header-nav .header-nav-wrapper > li > a:hover {
  color: #449aff;
  text-decoration: none;
}
#header .header-nav .header-nav-wrapper > li > a:hover .underline {
  opacity: 1;
  width: 100%;
  left: 0;
}
#header .header-nav .header-nav-wrapper > li > a:hover span {
  transform: rotate(180deg);
}
#header .header-nav .header-nav-wrapper > li.active > a {
  color: #449aff;
  text-decoration: none;
  border-bottom: 2px solid #449aff;
}
#header .header-nav .header-nav-wrapper > li > dl {
  display: none;
  position: absolute;
  width: 168px;
  top: 60%;
  left: 0;
  z-index: 999999;
  box-shadow: 0 0 3px 1px #ccc;
  background: #fff;
}
#header .header-nav .header-nav-wrapper > li > dl > dt {
  width: 100%;
  padding: 10px;
  border-bottom: 1px solid #ccc;
  z-index: 999999;
}
#header .header-nav .header-nav-wrapper > li > dl > dt > a:hover {
  text-decoration: none;
}
#header .header-nav .header-nav-wrapper > li:hover dl {
  display: block;
}
#header .header-nav .header-nav-wrapper > li > dl > dt:hover {
  cursor: pointer;
  background: #ccc;
}
@media screen and (min-width: 997px) and (max-width: 1175px) {
  #header .header-nav .header-nav-wrapper > li > a {
    font-size: 17px;
  }
}
@media screen and (min-width: 768px) and (max-width: 996px) {
  #header .header-nav .header-nav-wrapper > li > a {
    font-size: 16px;
  }
}
@media screen and (max-width: 997px) {
  #header-placeholder {
    height: 70px;
  }
  #header .header-nav-m {
    position: relative;
    width: 100%;
  }
  #header .header-nav-m .header-nav-m-logo {
    height: 70px;
    position: relative;
  }
  #header .header-nav-m .header-nav-m-logo img {
    height: 120px;
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    margin: auto;
  }
  #header .header-nav-m .header-nav-m-menu {
    color: #fff;
    height: 50px;
    font-size: 15px;
    line-height: 50px;
    background: #474747;
    position: relative;
  }
  #header .header-nav-m .header-nav-m-menu-wrapper {
    position: absolute;
    top: 50%;
    right: 20px;
    margin-top: -20px;
    width: 50px;
    height: 40px;
    color: #fff;
    z-index: 999999;
    font-size: 12px;
  }
  #header .header-nav-m .header-nav-m-wrapper {
    position: absolute;
    top: 50px;
    left: 0;
    width: 100%;
    background: #474747;
    z-index: 9999999;
  }
  #header .header-nav-m .header-nav-m-wrapper > li {
    height: 40px;
    line-height: 40px;
    border-bottom: 1px solid #ccc;
  }
  #header .header-nav-m .header-nav-m-wrapper > li > a {
    color: #fff;
    font-size: 15px;
    font-weight: bold;
    padding: 15px 0;
    position: relative;
  }
  #header .header-nav .header-nav-wrapper > li > a > span {
    font-size: 10px;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/Header.vue